import Membership from 'components/Profile/Insurance/Membership';

// The membership also lives inside the insurance step of the profile form, but a
// member who already finished that form has no reason to walk back through it —
// this is the page the sidebar link points at.
const MembershipPage = () => (
  <div className="space-y-5">
    <div>
      <h1 className="text-2xl font-bold text-secondary-900">My Membership</h1>
      <p className="mt-0.5 text-sm text-secondary-500">
        Your plan, what it costs and when it renews.
      </p>
    </div>

    <Membership />
  </div>
);

export default MembershipPage;
